import * as exercisesConstants from './exercises';
export var exercises = exercisesConstants;
export var issueCategories = [{
  key: 'not-accepted-right-answer',
  value: 'My answer is correct, but it is not accepted'
}, {
  key: 'feedback-not-helpful',
  value: 'The feedback on my submission(s) is not helpful'
}, {
  key: 'hint-not-helpful',
  value: 'The hint is not helpful'
}, {
  key: 'typo-ex',
  value: 'There is a typo in this exercise'
}, {
  key: 'other',
  value: 'Other'
}];